<template>
  <div>
    <div id="north">
      <header-info cur="1"></header-info>
    </div>
    <div class="searchres">
      <div class="search">
        <input
          type="text"
          placeholder=""
          :value="historyTxt"
          @keydown.enter="getInfo"
          @blur="getInfo"
        >
        <i class="iconfont">&#xe86e;</i>
      </div>
    </div>
    <div
      class="history"
      v-if="historyList.length"
    >
      <p>历史搜索</p>
      <ul>
        <li
          v-for="(item,index) in historyList"
          :key="index"
          @click="addIpt(item)"
        >{{item}}</li>
      </ul>
    </div>
    <div class="list">
      <ul>
        <li
          :class="isActive==1?'on':''"
          @click="isActive=1"
        >实验课程</li>
        <li
          :class="isActive==2?'on':''"
          @click="isActive=2"
        >实验学习</li>
        <li
          :class="isActive==3?'on':''"
          @click="isActive=3"
        >新闻资讯</li>
      </ul>

      <div
        class="mobile mobile-item"
        v-show="isActive==1"
      >
        <ul class="mobile-item-list">
          <li
            v-for="item in experimentData"
            :key="item.id"
          >
            <router-link :to="'/www/experiment?id=' + item.id">
              <div class="img-wrap">
                <img
                  :src="item.logo"
                  :onerror="$store.state.defaultImg"
                />
              </div>
              <p class="biaoti">{{item.title}}</p>
              <p class="p1">
                <span>{{item.school?item.school.title?item.school.title:'--':'--'}}</span>
                <span class="line">|</span>
                <span>{{item.master_name?item.master_name:'--'}}</span>
              </p>
            </router-link>
          </li>
          <li
            class="no-info"
            v-if="!experimentData.length"
          >暂无数据</li>
        </ul>
      </div>
      <div
        class="mobile mobile-item"
        v-show="isActive==2 "
      >
        <ul class="mobile-item-list">
          <li
            v-for="item in lessonData"
            :key="item.id"
          >
            <router-link :to="'/www/lesson_detail?id=' + item.id">
              <div class="img-wrap">
                <img
                  :src="item.logoPath"
                  :onerror="$store.state.defaultImg"
                />
              </div>
              <p class="biaoti">{{item.title}}</p>
              <p class="p1">
                <span>第一学期</span>
              </p>
              <p class="p1">
                <span>进行第{{formatWeek(item.startTime)}}周，共{{item.allTime}}周</span>
              </p>
              <p class="p1">
                <span v-if="item.manager.school">{{item.manager.school.title?item.manager.school.title:'--'}}</span>
                <span class="line">|</span>
                <span>{{item.manager?item.manager.name:'--'}}</span>
              </p>
            </router-link>
          </li>
          <li
            class="no-info"
            v-if="!lessonData.length"
          >暂无数据</li>
        </ul>
      </div>
      <div
        class="mobile"
        v-show="isActive==3"
      >
        <ul class="list-info">
          <router-link
            tag="li"
            v-for="item in infoData"
            :key="item.id"
            :to="'/www/news/detail?id=' + item.id + '&category='+item.category"
          >
            <p>{{item.title}}</p>
            <p v-html="item.contents"></p>
            <p>{{item.created.substr(0,10).replace(/-/g,'/')}}</p>
          </router-link>
          <li
            class="no-info"
            v-if="!infoData.length"
          >暂无数据</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderInfo from '../../../components/HeaderInfo'
export default {
  name: 'SearchList',
  components: {
    HeaderInfo
  },
  data() {
    return {
      isActive: '1',
      experimentData: [],
      experimentDataCount: 0,
      lessonData: [],
      lessonDataCount: 0,
      infoData: [],
      infoDataCount: [],
      queryExpInfo: {
        page: 1,
        size: 100,
        experiment_title: ''
      },
      queryLessonInfo: {
        page: 1,
        size: 100,
        title: ''
      },
      queryInfo: {
        page: 1,
        size: 100,
        experiment_title: ''
      },
      historyArr: [],
      historyTxt: ''
    }
  },
  computed: {
    historyList() {
      return this.$store.state.historyList
    }
  },
  methods: {
    addIpt(val) {
      this.historyTxt = val
      this.queryExpInfo.experiment_title = val
      this.getExperiment()
      this.queryLessonInfo.title = val
      this.getLessonOnline()
      this.queryInfo.title = val
      this.searchExperimenth()
    },
    // 计算当前时间处于第几周
    getWeek (dt) {
      var _this = this
      const yy = new Date().getFullYear()
      const mm = new Date().getMonth() + 1
      const dd = new Date().getDate()
      _this.gettime = yy + '-' + mm + '-' + dd
      const d1 = new Date(dt) // 开始时间
      const d2 = new Date(_this.gettime) // 当前时间日期
      const rq = d2 - d1
      const days = Math.ceil(rq / (24 * 60 * 60 * 1000))
      const num = Math.ceil(days / 7)
      return num
    },
    formatWeek(val) {
      var num = this.getWeek(val)
      return num
    },
    getInfo(e) {
      if (e.target.value) {
        this.$store.commit('setHistory', e.target.value)
        this.queryExpInfo.experiment_title = e.target.value
        this.getExperiment()
        this.queryLessonInfo.title = e.target.value
        this.getLessonOnline()
        this.queryInfo.title = e.target.value
        this.searchExperimenth()
      }
    },
    // 实验
    async getExperiment() {
      this.searchTxt = this.queryInfo.experiment_title
      await this.$http.get('/experiment_search/', {
        params: this.queryExpInfo
      }).then((data) => {
        this.experimentData = data.data.results
        this.experimentDataCount = data.data.count
      }).catch(() => {
        this.$layer.msg('获取信息失败！')
      })
    },
    // 课程
    async getLessonOnline() {
      await this.$http.get('/allowany/lesson_online/', {
        params: this.queryLessonInfo
      }).then((data) => {
        this.lessonData = data.results
        this.lessonDataCount = data.count
      }).catch(() => {
        this.$layer.msg('获取信息失败！')
      })
    },
    async searchExperimenth() {
      await this.$http.get('/allowany/info/', {
        params: this.queryInfo
      }).then((data) => {
        this.infoData = data.results
        this.infoDataCount = data.count
      }).catch(() => {
        this.$layer.msg('获取资讯信息失败！')
      })
    }
  }
}
</script>

<style lang="less" scoped>
.list > ul {
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-bottom: 1px solid #c9c9c9;
  li {
    line-height: 30px;
    border-bottom: 2px solid transparent;
    &.on {
      border-bottom: 2px solid #73D6CA;
    }
  }
}
.list-info {
  padding: 10px 15px;
  li {
    margin-bottom: 20px;
    border-bottom: 1px solid #efefef;
    padding-bottom: 5px;
    & > p {
      &:first-child {
        font-size: 15px;
        color: #333;
        margin-bottom: 10px;
      }
      &:nth-child(2n) {
        font-size: 14px;
        color: #999;
        margin-bottom: 10px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
      }
      &:last-child {
        font-size: 12px;
        color: #ccc;
      }
    }
  }
}
.no-info {
  text-align: center;
  border: none !important;
}
</style>
